import React, { createContext } from "react";

export const TableDrawer=createContext()